module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis.8797d00d20c787dd3b8d8c2d73923cd7.png";